import { datatableInit } from "../functions/datatableInit"
import {select2Init} from "../functions/select2Init"

import{
    trans,
    BRAK,
    NUMER_LOKALIZACJI,
    ADRES,
    KOD_POCZTOWY,
    NUMER_TELEFONU,
    MAKROREGION,
    REGION,
    OKREG,
    REJON,

} from '../../../translator';


const loader = window.customLoader

const correctiveActionListClient = () => {

    $('#search-filters').on('click', function () {
        $('.datatable').DataTable().ajax.reload()
    })

    $('#reset-filters').on('click', function () {
        $('#number').val('');
        $('#macroregion').val('').change();
        $('#region').val('').change();
        $('#district').val('').change();
        $('#area').val('').change();
        $('#round').val('').change();
        $('#auditor').val('').change();
        $('#feature').val('').change();
        $('#date-planned-from').val('');
        $('#date-planned-to').val('');
        $('#date-implementation-from').val('');
        $('#date-implementation-to').val('');
        $('#result-from').val('');
        $('#result-to').val('');
        $('#status').val('').change();
        $('.datatable').DataTable().ajax.reload()
    })


    $('.datatable tbody').on('click', '.open-shop', function () {

        loader.show()

        const id = $(this).data('id')
        const tr = $(this).closest('tr')
        const row = $('.datatable').DataTable().row( tr );

        if ( row.child.isShown() ) {
            row.child.hide();
            tr.removeClass('shown');

            loader.hide()
        }
        else {
            $.ajax({
                type: 'post',
                url: Routing.generate('location_details', {id: id}),
            }).then(result => {

                if (result['number'] == null)
                {
                    result['number'] = trans(BRAK)
                }
                if (result['address'] == null)
                {
                    result['address'] = trans(BRAK)
                }
                if (result['city'] == null)
                {
                    result['city'] = trans(BRAK)
                }
                if (result['zipCode'] == null)
                {
                    result['zipCode'] = trans(BRAK)
                }
                if (result['phoneNumber'] == null)
                {
                    result['phoneNumber'] = trans(BRAK)
                }
                if (result['macroregion'] == null)
                {
                    result['macroregion'] = trans(BRAK)
                }
                if (result['region'] == null)
                {
                    result['region'] = trans(BRAK)
                }
                if (result['district'] == null)
                {
                    result['district'] = trans(BRAK)
                }
                if (result['area'] == null)
                {
                    result['area'] = trans(BRAK)
                }

                row.child(

                    '<table class="location-info" style="padding-left:50px;">' +
                    '<tr>' +
                    '<td class="text-center" trans(NUMER_LOKALIZACJI)</td>' +
                    '<td class="text-center">trans(ADRES)</td>' +
                    '<td class="text-center">trans(KOD_POCZTOWY)</td>' +
                    '<td class="text-center">trans(NUMER_TELEFONU)</td>' +
                    '<td class="text-center">trans(MAKROREGION)</td>' +
                    '<td class="text-center">trans(REGION)</td>' +
                    '<td class="text-center">trans(OKREG)</td>' +
                    '<td class="text-center">trans(REJON)</td>' +
                    '</tr>' +
                    '<tr>' +
                    '<td class="text-center">' + result['number'] + '</td>' +
                    '<td class="text-center">' + result['address'] + ' ' + result['city'] +'</td>' +
                    '<td class="text-center">' + result['zipCode'] + '</td>' +
                    '<td class="text-center">' + result['phoneNumber'] + '</td>' +
                    '<td class="text-center">' + result['macroregion'] + '</td>' +
                    '<td class="text-center">' + result['region'] + '</td>' +
                    '<td class="text-center">' + result['district'] + '</td>' +
                    '<td class="text-center">' + result['area'] + '</td>' +
                    '</tr>' +
                    '</table>'

                ).show();
                tr.addClass('shown');

                loader.hide()
            })
        }
    } );

    $(() => {

        datatableInit('.datatable', {
            columns: [
                { name: 'q.question'},
                { name: 'q.code'},
                { name: 'l.number'},
                { name: 'lastComment', orderable: false },
                { name: 'a.dateImplementation'},
                { name: 's.name'},
            ],
            // order: [0, 'desc'],
            bServerSide: true,
            stateSave: true,
            paginate: true,
            processing: true,
            bDestroy: true,
            autoWidth: false,
            lengthMenu: [25,50,100],
            ajax: {
                beforeSend: function (){
                    loader.show()
                },
                data: function ( d ) {
                    d.number = $('#number').val()
                    d.macroregion = $('#macroregion :selected').data('macroregion');
                    d.region = $('#region :selected').data('region');
                    d.district = $('#district :selected').data('district');
                    d.area = $('#area :selected').data('area');
                    d.round = $('#round :selected').data('round');
                    d.auditor = $('#auditor :selected').data('auditor');
                    d.feature = $('#feature :selected').data('feature');
                    d.dateImplementationFrom = $('#date-implementation-from').val();
                    d.dateImplementationTo = $('#date-implementation-to').val();
                    d.status = $('#status :selected').data('status');
                },
                url: Routing.generate('corrective_action_list_ajax'),
                type: "POST",
                complete: function (){
                    loader.hide()
                }
            },
        })
    })


    select2Init('select[data-select=select2]')

    select2Init('select[data-select=select2-none-search]', {
        minimumResultsForSearch: Infinity
    })
}

window.initCorrectiveActionListClient = () => {
    correctiveActionListClient()
}